import { gql } from '@apollo/client';

export default gql`
  query GeneratePassengerPrintCommands($bookingReference: String!) {
    generatePassengerPrintCommands(bookingReference: $bookingReference) {
      passengerId
      printCommand
      itemRef
    }
  }
`;
